import dayjs from 'dayjs'

import OrionError from '../error/OrionError'

interface DateUtilFormat {
  format(value: Date, targetFormat: string): string
  format(value: string, sourceFormat: string, targetFormat: string): string
}

export interface DateUtilI {
  format: DateUtilFormat['format']
  stringToDate(value: string, format: string): Date
}

const DateUtil: DateUtilI = {
  format(p1: Date | string, p2: string, p3?: string) {
    if (p1 instanceof Date && typeof p2 === 'string') {
      const value = p1
      const format = p2

      if (!value) {
        throw new OrionError('value is null.')
      }

      if (!format) {
        throw new OrionError('format is null.')
      }

      return dayjs(value).format(format)
    } else if (typeof p1 === 'string' && typeof p2 === 'string' && typeof p3 === 'string') {
      const value = p1
      const sourceFormat = p2
      const targetFormat = p3

      if (!value || !sourceFormat || !targetFormat) {
        throw new OrionError(`Invalid arguments: ${value}, ${sourceFormat}, ${targetFormat}`)
      }

      if (dayjs(value, sourceFormat, true).isValid()) {
        return dayjs(value, sourceFormat).format(targetFormat)
      } else {
        throw new OrionError(`日期[${value}]与格式[${sourceFormat}]不匹配。`)
      }
    } else {
      throw new OrionError(`入参数量[${arguments.length}]不正确。`)
    }
  },

  stringToDate(value: string, format: string): Date {
    if (!value) {
      throw new OrionError('value is null.')
    }

    if (!format) {
      throw new OrionError('format is null.')
    }

    if (typeof value !== 'string') {
      throw new OrionError('value is not a string.')
    }

    if (typeof format !== 'string') {
      throw new OrionError('format is not a string.')
    }

    if (dayjs(value, format, true).isValid()) {
      return dayjs(value, format).toDate()
    } else {
      throw new OrionError(`日期[${value}]与格式[${format}]不匹配。`)
    }
  },
}

export default DateUtil
